import React from 'react';
import {VerizonAsurionLogo} from "../../../common";

export const Branding: React.FC = () => <VerizonAsurionLogo data-testid='branding'/>;
